import { Redirect } from "expo-router";
import { View } from "react-native";
import { useTenant } from "@src/features/tenants";
import { BackgroundGradient } from "@src/components/BackgroundGradient";

export default function TrafficFlowTabRedirect() {
  const { selectedTenant } = useTenant();

  if (selectedTenant?.id) {
    return <Redirect href={`/tenants/${selectedTenant.id}/traffic-flow` as never} />;
  }

  return (
    <BackgroundGradient>
      <View style={{ flex: 1, backgroundColor: "transparent" }} />
    </BackgroundGradient>
  );
}
